module.exports = __webpack_public_path__ + "cd455783/img/share-action-icon.9c12578c.svg";